'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAccountLocale = exports.UPDATE_ACCOUNT_LOCALE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.doUpdateAccountLocale = doUpdateAccountLocale;
exports.watchAccountLocaleSagas = watchAccountLocaleSagas;

var _effects = require('redux-saga/effects');

var _modals = require('redux/modules/modals');

var _selectors = require('redux/saga/selectors');

var _cookies = require('redux/saga/helpers/cookies');

var _multitrack = require('helpers/multitrack');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doUpdateAccountLocale),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchAccountLocaleSagas);

var UPDATE_ACCOUNT_LOCALE = exports.UPDATE_ACCOUNT_LOCALE = 'UPDATE_ACCOUNT_LOCALE';

var updateAccountLocale = exports.updateAccountLocale = function updateAccountLocale(locale) {
  return { type: UPDATE_ACCOUNT_LOCALE, locale: locale };
};

function doUpdateAccountLocale(client, _ref) {
  var locale = _ref.locale;
  var loggedIn;
  return _regenerator2.default.wrap(function doUpdateAccountLocale$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.spawn)(_multitrack.ga, 'Locale Switched', 'Changed', locale);

        case 2:
          _context.next = 4;
          return (0, _effects.spawn)(_multitrack.ga, 'Footer', 'Click - Updated Locale', locale);

        case 4:
          _context.next = 6;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 6:
          loggedIn = _context.sent;

          if (!loggedIn) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return (0, _effects.call)(client.users.updateUserProfile, {
            locale: locale
          });

        case 10:
          _context.next = 12;
          return (0, _effects.put)((0, _modals.hideModal)('LocaleModal'));

        case 12:
          (0, _cookies.setCookie)('locale', locale, {
            path: '/'
          });
          window.location.reload();

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchAccountLocaleSagas(client) {
  return _regenerator2.default.wrap(function watchAccountLocaleSagas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, UPDATE_ACCOUNT_LOCALE, doUpdateAccountLocale, client);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}